import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import { completeAddToCart, sendProductForm, startAddToCartLoading } from 'helpers/addToCartButton';
import PanelPage from 'navigation/pages/PanelPage';
import store from 'store';
export default class Quickbuy extends PanelPage {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            quickbuyForm: ['.form.quickbuy_form', Form]
        };
    }
    resize() {
        super.resize();
        this.el.style.setProperty('--size-header-height', `${this.refs.quickBuyHeader.offsetHeight}px`);
        this.el.style.setProperty('--size-confirm-height', `${this.refs.quickBuyConfirm.offsetHeight}px`);
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        this.refs.addToCart[method]('click', this.onAddToCart);
    }
    onAddToCart = async (e) => {
        const valid = await this.modules.quickbuyForm.quickValid();
        if (!valid)
            return;
        const target = e.currentTarget;
        const btns = [this.refs.addToCart];
        await startAddToCartLoading(btns);
        sendProductForm({
            form: this.modules.quickbuyForm,
            submitter: target,
            callback: ({ xhr, data }) => {
                completeAddToCart(btns, data.error !== null);
                setTimeout(() => {
                    store.panel.set(null);
                }, 500);
            }
        });
    };
}
